import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2 className="modal-title" style={{ margin: 0 }}>{title}</h2>
          <button 
            onClick={onClose}
            style={{ 
              background: 'transparent', 
              border: 'none', 
              fontSize: '1.5rem', 
              cursor: 'pointer',
              color: 'var(--muted-foreground)',
              lineHeight: 1
            }}
          >
            &times;
          </button>
        </div>
        
        <div className="modal-body">
          {children}
        </div>

        {footer && (
          <div className="modal-actions" style={{ marginTop: '2rem' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type?: 'info' | 'error' | 'success';
}

export const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'info',
}) => {
  const buttonClass = type === 'error' ? 'variant-destructive' : 'variant-success';
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <p className="modal-message">{message}</p>
      <div className="modal-actions" style={{ marginTop: '2rem' }}>
        <button 
          onClick={onClose} 
          className={`modal-btn-confirm ${buttonClass}`}
          style={{ width: '100%' }}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

